import { render, staticRenderFns } from "./PageNotes.vue?vue&type=template&id=609feede&scoped=true&"
import script from "./PageNotes.vue?vue&type=script&lang=js&"
export * from "./PageNotes.vue?vue&type=script&lang=js&"
import style0 from "./PageNotes.vue?vue&type=style&index=0&id=609feede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609feede",
  null
  
)

export default component.exports